import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';

import { requestRunAutomations, requestRunAutomationsAndSendReminderEmails, startSyncingOrganization } from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

class RunAutomationButton extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  close() {
    this.setState({ open: false });
  }

  open() {
    this.setState({ open: true });
  }

  
  handleSubmit() {
    const { organization, isReminder } = this.props;
    const task = isReminder ? requestRunAutomationsAndSendReminderEmails : requestRunAutomations;

    this.props.dispatch(startSyncingOrganization(organization._id));
    this.props.dispatch(task())
      .catch((error) => {
        const el = <div>Automations failed to run<br />{error.data.message}</div>;
        this.context.addNotification(el, { type: 'error', autoClose: true });
      });
    this.close();
  }

  renderModal() {
    let title = 'Run All Automations';
    let body = 'Are you sure you want to have TruVoice Automation submit contacts for all qualified opportunities based on your current automations settings now?';
    let btn = 'Run Now';

    if (this.props.isReminder) {
      title = 'Send Reminder Emails for Qualified Opportunities Now?';
      body = 'Are you sure you want to have TruVoice Automation send reminder emails for all qualified opportunities based on your current reminder email settings now?';
      btn = 'Send Now';
    }

    return (
      <Modal show={this.state.open} onHide={this.close} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>{body}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button className="pull-left" bsStyle="default" onClick={this.close}>Cancel</Button>
            <Button className="pull-right" bsStyle="warning" onClick={this.handleSubmit}><Fa name="play" /> {btn}</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {    
    return (
      <span>
        {this.renderModal()}
        <Button onClick={this.open} bsStyle="warning">
          <Fa name="play" /> {this.props.title}
        </Button>
      </span>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

RunAutomationButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  isReminder: PropTypes.bool,
  title: PropTypes.string,
};
RunAutomationButton.defaultProps = {
  isReminder: false,
  title: 'Run Automations',
};
RunAutomationButton.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(RunAutomationButton);
